// extracted by mini-css-extract-plugin
module.exports = {"container":"src-components-UI-AppNameEdit-AppName-module__container--3tJHR","name":"src-components-UI-AppNameEdit-AppName-module__name--NokI5"};